import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommercialOutOfJurisdictionRegistrationService } from '@max/commercialpermitting/services/commercial-out-of-Jurisdiction-registration.service';
import { SharedPipesModule } from '@max/shared/pipes/shared-pipes.module';
import { SharedModule } from '@max/shared/shared.module';
import { TableModule } from 'primeng/table';
import { OutOfJurisdictionRegistrationHistoryModalComponent } from './out-of-jurisdiction-registration-history-modal.component';

@NgModule({
    declarations: [
        OutOfJurisdictionRegistrationHistoryModalComponent
    ],
    providers: [
        CommercialOutOfJurisdictionRegistrationService
    ],
    imports: [
        SharedModule,
        CommonModule,
        SharedPipesModule,
        TableModule
    ],
    exports: [
        OutOfJurisdictionRegistrationHistoryModalComponent
    ]
})
export class OutOfJurisdictionRegistrationHistoryModalModule {
}
